<section>
    <h4><u>Upload tax-Exempt Forms:</u></h4>
    <p>Upload a new tax exempt document (pdf only), you must select the calendar year the document applies to as well.
    </p>
    <table>
        <tr>
            <td>
                Upload Tax-Exempt Document:</td>
            <td><input type="file" #fileInput (change)="onFileSelected($event)"></td>
        </tr>
        <tr>
            <td colspan="2"></td>
        </tr>
        <tr>
            <td>Select A Year For This Document: </td>
            <td>
                <select id="filterYears" required class="select" [(ngModel)]="selectedYear">
                    @for (y of yearsList; track y) {
                    <option [value]="y.year">
                        {{y.year}}
                    </option>
                    }
                </select>
                *Valid for the calendar year selected only.
            </td>
        </tr>
        <tr>
            <td colspan="2" style="text-align: right;">
                <button id="uploadButton" [disabled]="!selectedFile" (click)="uploadFile()">Upload Document</button></td>
        </tr>
    </table>


    @if(progress) {
    <div>
        <p class="msg">
            Upload progress: {{ progress }}%.&nbsp;
            {{ msg }}
        </p>
    </div>
    } @else {
        <p class="errormsg">{{ errormsg }}</p>
    }

    <!-- @if(uploadResult) {
    <div>
        @if(uploadResult.success) {
        <p class="msg">
            Upload successful! Blob URL: <a [href]="uploadResult.blobUri" target="_blank">{{ uploadResult.blobUri }}</a>
        </p>
        }
        @if(!uploadResult.success) {
        <p class="errormsg">
            Upload failed: {{ uploadResult.errorMessage }}
        </p>
        }
    </div>
    } -->
</section>

<section>
    <h4><u>Select Year to view the previous tax exempt documents:</u></h4>
    
    <div>
        @for(y of allYears; track y){
            <label>
                <input type="checkbox" (change)="toggleYear(y, $event)" />
                {{ y }}
            </label>
        }
    </div>
    
    @if(loading){
        <div>Loading...</div>
    }

    <div>
        @for(yr of this.selectedYears; track yr) {
        <h3>{{ yr }}</h3>        
        <table style="width: 100%;">
            <tr>
                <th style="width: 60%;">File</th>
                <!-- <th style="width: 20%;text-align: left;">Size</th> -->
                <th style="width: 30%;text-align: left;">Created On</th>
                <th style="width: 10%;text-align: left;">View</th>
            </tr>
            @for(file of filesByYear[yr]; track file) {
            <tr>
                <td>{{ file.fileName }}</td>
                <!-- <td>{{ file.size | number:'1.0-2'}}</td> -->
                <td>{{ dateFormat(file.createdOn) }}</td>
                <td><button (click)="viewFile(file.blobName)">View File</button></td>
            </tr>
            }
        </table>        
        }
    </div> 
    <br>   
</section>